import axios from '@/core/http'
import { JOIN } from './toolkit'

export const fetchMissingPublications = ({
  page,
  pageSize,
  ordering,
  dateStart,
  dateEnd,
  query,
  state,
  statuses,
  excludeUsers,
  includeUsers,
  developers,
  exclusions,
  plugable,
  categories,
  industries,
}) => {
  return axios
    .get('missing/publications/', {
      params: {
        ['page']: page,
        ['page_size']: pageSize || 20,
        ['ordering']: ordering || undefined,
        ['for_parsing']: true,
        ['date_start']: (dateStart && dateStart.format('YYYY-MM-DD')) || undefined,
        ['date_end']: (dateEnd && dateEnd.format('YYYY-MM-DD')) || undefined,
        ['query']: query || undefined,
        ['spider_state']: state || undefined,
        ['spider_status']: JOIN(statuses),
        ['exclude_users']: JOIN(excludeUsers),
        ['include_users']: JOIN(includeUsers),
        ['developers']: JOIN(developers),
        ['exclusions']: exclusions || undefined,
        ['plugable']: plugable ?? undefined,
        ['source_category']: JOIN(categories),
        ['source_industry']: JOIN(industries),
      },
    })
    .then(res => res.data)
}
export const updateMissingPublications = (ids, { status }) => {
  return axios.patch('missing/publications/bulk-update/', { ids, status }).then(res => res.data)
}

export const fetchMissingPublicationsTop = ({
  dateStart,
  dateEnd,
  state,
  statuses,
  excludeUsers,
  includeUsers,
  developers,
  exclusions,
  plugable,
  categories,
  industries,
}) => {
  return axios
    .get('missing/publications/chart/', {
      params: {
        ['date_start']: (dateStart && dateStart.format('YYYY-MM-DD')) || undefined,
        ['date_end']: (dateEnd && dateEnd.format('YYYY-MM-DD')) || undefined,
        ['for_parsing']: true,
        ['spider_state']: state || undefined,
        ['spider_status']: JOIN(statuses),
        ['exclude_users']: JOIN(excludeUsers),
        ['include_users']: JOIN(includeUsers),
        ['developers']: JOIN(developers),
        ['exclusions']: exclusions || undefined,
        ['plugable']: plugable ?? undefined,
        ['source_category']: JOIN(categories),
        ['source_industry']: JOIN(industries),
      },
    })
    .then(res => res.data)
}

export const bulkCreateSourceExclusion = ({ ids, note }) => {
  return axios.post('missing/source-exclusions/bulk-create/', { ids, note }).then(res => res.data)
}
